import * as urlUtils from 'privates/urlUtils';

function getViewMode () {
    return urlUtils.getQueryParameter('viewMode');
}

export default {
    getViewMode
};



// WEBPACK FOOTER //
// ./js/modules/privates/viewMode.es6